import React, { Component } from "react";
import Auth from "Api/Auth";
import moment from "moment";
import Api from "Api/Api";
import Utils from "Utils";
import { SelectBox, DateBox, FileUploader } from "devextreme-react";
import { connect } from "react-redux";
import DataGrid, { Column } from "devextreme-react/data-grid";

function mapStateToProps(state) {
  return {
    section: state.section,
  };
}
class CommWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showData: false,
      moderator: false,
      showUploadForm: false,
      data: [],
      investors_choice: props.investors,
      investor: "",
      chat_type: "",
      startupState: null,
      created: null,
    };
    this.showData = () => {
      if (!this.state.showData) {
        var decodedToken = Auth.decodedToken();
        this.setState({ moderator: decodedToken.moderator });
        if (decodedToken.moderator) {
          this.setState(
            {
              investors_choice: this.props.investors,
              investor: this.props.investors[0],
            },
            () => {
              // fetching chat data for first investor
              Api.getChatData(
                this.state.investor.id,
                this.props.startupID
              ).then((response) => {
                if (response.status === 200) {
                  this.setState({
                    data: response.data,
                  });
                }
              });
            }
          );
        } else {
          var startupID = window.location.pathname.split("/").splice(-1)[0];
          Api.getChatData(decodedToken.id, startupID).then((response) => {
            if (response.status === 200) {
              this.setState({ data: response.data });
            }
          });
        }
      }
      this.setState({ showData: !this.state.showData });
    };
    this.showUploadForm = () => {
      if (this.state.investor !== "") {
        this.setState({ showUploadForm: !this.state.showUploadForm });
      } else {
        Utils.notify("Please select investor first", "warning");
      }
    };
    this.createChat = (e) => {
      e.preventDefault();
      var forms = document.forms["newChat"];
      var data = new FormData();
      data.append("investor", this.state.investor.id);
      data.append("startup", this.props.startupID);
      data.append("posted_by", forms.posted_by.value);
      data.append("description", forms.description.value);
      data.append("created", forms.created.value);
      if (forms.file.files[0]) {
        data.append("document", forms.file.files[0]);
      }
      data.append("chat_type", this.state.chat_type);
      this.props.dispatch({ type: "toggleLoad" });
      Api.createChat(data).then((response) => {
        if (response.status === 201) {
          this.props.dispatch({ type: "toggleLoad" });
          Utils.notify("Chat has been uploaded!", "success");
          this.setState({
            data: [...this.state.data, response.data],
            showUploadForm: false,
          });
        }
      });
    };
    this.investorSelected = (e) => {
      this.setState({ investor: e.value });
      this.props.dispatch({ type: "toggleLoad" });
      Api.getChatData(e.value.id, this.props.startupID).then((response) => {
        if (response.status === 200) {
          this.props.dispatch({ type: "toggleLoad" });
          this.setState({ data: response.data });
        }
      });
    };
    this.showUploadData = () => {
      return (
        <div>
          {this.state.moderator ? (
            <div className="row">
              <div className="col-lg-6">
                <SelectBox
                  dataSource={this.state.investors_choice}
                  displayExpr={"username"}
                  placeholder={"Select Investor"}
                  value={this.state.investor}
                  searchEnabled={true}
                  onValueChanged={this.investorSelected}
                  stylingMode="underlined"
                />
              </div>
            </div>
          ) : null}

          <div className="table-responsive">
            <DataGrid
              dataSource={this.state.data}
              searchPanel={{ visible: true }}
              wordWrapEnabled={true}
              hoverStateEnabled={true}
            >
              <Column dataField="investor_name" caption="Investor's name" />
              <Column dataField="fund_name" caption="Fund name" />
              <Column dataField="contact_person" caption="Contact person" />
              <Column dataField="posted_by" />
              <Column dataField="description" />
              <Column
                dataField="created"
                cellRender={(row) => {
                  return <div>{moment(row.data.created).format("LLLL")}</div>;
                }}
              />
              <Column
                dataField="document"
                caption="Attachment"
                cellRender={(row) => {
                  return (
                    <div>
                      <a
                        href={row.data.document}
                        className="material-icons"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        attachment
                      </a>
                    </div>
                  );
                }}
              />
            </DataGrid>

            {this.state.moderator ? (
              <div>
                <button className="btn btn-info" onClick={this.showUploadForm}>
                  Upload new
                </button>
                {this.state.showUploadForm ? (
                  <form
                    onSubmit={this.createChat}
                    name="newChat"
                    className="container"
                  >
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="posted_by"
                            className="form-control"
                            placeholder={"Posted by (Required)"}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="description"
                            placeholder={"Description (Required)"}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <DateBox
                            type={"datetime"}
                            stylingMode={"underlined"}
                            style={{ width: "20%" }}
                            className="form-control"
                            width={"100%"}
                            name={"created"}
                            placeholder={"Created (Required)"}
                          />
                        </div>
                      </div>
                      <div className="col-lg-1">
                        <h5 style={{ marginTop: 25 }}>Chat file</h5>
                      </div>
                      <div className="col-lg-5">
                        <FileUploader name={"file"} uploadMode={"useForm"} />
                      </div>
                    </div>
                    <button className="btn btn-success" type="submit">
                      Upload
                    </button>
                  </form>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      );
    };
  }

  componentDidMount() {
    var chat_type;
    if (this.props.section === "Seconday Stake") {
      chat_type = "Bidding";
    } else {
      chat_type = "Investment";
    }
    this.setState({
      chat_type,
    });
  }

  render() {
    return (
      <div>
        <button className="btn btn-primary" onClick={this.showData}>
          {this.state.moderator ? "Update Chats" : "Chat"}
        </button>
        {this.state.showData ? this.showUploadData() : null}
      </div>
    );
  }
}
export default connect(mapStateToProps)(CommWidget);
